export default __webpack_public_path__ + "static/media/photo.3f1bffae.svg";